import store from '@/store';

function isGranted (roles) {
  return store.getters['auth/hasRole'](roles);
}

export default {
  install: function (Vue) {
    Vue.prototype.$isGranted = isGranted;
  },
};
